var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomtailored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3748,
    height: 2495.87,
    viewBox: "0 0 3748 2495.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "FLOOR",
    points: "3748 2495 0 2495 672.8 2097.7 3085.5 2097.7 3748 2495",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LAPTOP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2148.9,552.7H1474.6V162.8a47.8,47.8,0,0,1,47.8-47.8h578.7a47.8,47.8,0,0,1,47.8,47.8Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098,527.3H1528.3a27.23,27.23,0,0,1-27.2-27.2V165.9a27.23,27.23,0,0,1,27.2-27.2H2098a27.23,27.23,0,0,1,27.2,27.2V500.2A27.14,27.14,0,0,1,2098,527.3Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2267.1,644.2c25.8,16.8,19.8,49.7-10.7,49.7H1337.8c-25.7,0-34.5-34.7-9.3-50.6Z",
    fill: "#66b0f0",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256.4,671H1337.8c-16.4,0-22.9-19.3-9.3-27.7l146.3-90.6H2147l120,91.5C2279,653.3,2272,671,2256.4,671Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150.4,643.7H1443.8c-12.6,0-17.6-14.9-7.2-21.3l101.6-69.7h528l92.3,70.4C2167.8,630.1,2162.4,643.7,2150.4,643.7Z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2020.5,
    y1: 552.7,
    x2: 2112.9,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1971.5,
    y1: 552.7,
    x2: 2052.9,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1925.7,
    y1: 552.7,
    x2: 1996.3,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1874.5,
    y1: 552.7,
    x2: 1934.2,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1832,
    y1: 552.7,
    x2: 1861.1,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1581.1,
    y1: 552.7,
    x2: 1488.7,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1630.1,
    y1: 552.7,
    x2: 1548.7,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1675.9,
    y1: 552.7,
    x2: 1605.3,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1727.1,
    y1: 552.7,
    x2: 1667.4,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1769.6,
    y1: 552.7,
    x2: 1740.5,
    y2: 643.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1798.4,
    y1: 644.8,
    x2: 1798.4,
    y2: 552.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1488.7,
    y1: 586.7,
    x2: 2110.9,
    y2: 586.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "SHIRT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2050.6,527.3H1544.7l9.1-64.5a101.41,101.41,0,0,1,72.6-83.3l123.3-25.6h95.9l123.3,25.6a101,101,0,0,1,72.6,83.3Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.8,427.6l-36.5-36.9a2,2,0,1,1,2.8-2.8l33.5,33.9,52-58.9a2,2,0,1,1,3,2.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764,427.6l-54.8-62.1a2,2,0,0,1,3-2.6l52,58.9,33.5-33.9a2,2,0,0,1,2.8,2.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.5,451.7a8.7,8.7,0,1,1,8.7-8.7A8.71,8.71,0,0,1,1798.5,451.7Zm0-13.4a4.7,4.7,0,1,0,4.7,4.7A4.69,4.69,0,0,0,1798.5,438.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.5,500.7a8.7,8.7,0,1,1,8.7-8.7A8.71,8.71,0,0,1,1798.5,500.7Zm0-13.4a4.7,4.7,0,1,0,4.7,4.7A4.69,4.69,0,0,0,1798.5,487.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1749.1 525.2 1585.7 525.2 1542.1 395.8 1705.5 349 1749.1 525.2",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.2,412.6h-3.1a14.3,14.3,0,0,1-14.3-14.3V353.4a5.8,5.8,0,0,1,5.8-5.8h13.5a5.8,5.8,0,0,1,5.8,5.8v51.4A7.66,7.66,0,0,1,1594.2,412.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.2,412.6h-3.1a14.3,14.3,0,0,1-14.3-14.3V353.4a5.8,5.8,0,0,1,5.8-5.8h13.5a5.8,5.8,0,0,1,5.8,5.8v51.4A7.66,7.66,0,0,1,1594.2,412.6Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660,412.6h3.1a14.3,14.3,0,0,0,14.3-14.3V353.4a5.8,5.8,0,0,0-5.8-5.8H1658a5.8,5.8,0,0,0-5.8,5.8v51.4A7.81,7.81,0,0,0,1660,412.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.3,417.8h-7.2a10.07,10.07,0,0,1-10.1-10.1V353.5a5.8,5.8,0,0,1,5.8-5.8h13.5a5.8,5.8,0,0,1,5.8,5.8V410A7.81,7.81,0,0,1,1619.3,417.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.5,419.8h-6a11.39,11.39,0,0,1-11.4-11.4v-55a5.8,5.8,0,0,1,5.8-5.8h13.5a5.8,5.8,0,0,1,5.8,5.8V412A7.79,7.79,0,0,1,1644.5,419.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660,412.6h3.1a14.3,14.3,0,0,0,14.3-14.3V353.4a5.8,5.8,0,0,0-5.8-5.8H1658a5.8,5.8,0,0,0-5.8,5.8v51.4A7.81,7.81,0,0,0,1660,412.6Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.3,417.8h-7.2a10.07,10.07,0,0,1-10.1-10.1V353.5a5.8,5.8,0,0,1,5.8-5.8h13.5a5.8,5.8,0,0,1,5.8,5.8V410A7.81,7.81,0,0,1,1619.3,417.8Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.5,419.8h-6a11.39,11.39,0,0,1-11.4-11.4v-55a5.8,5.8,0,0,1,5.8-5.8h13.5a5.8,5.8,0,0,1,5.8,5.8V412A7.79,7.79,0,0,1,1644.5,419.8Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1845.7,295.1v73c0,12.6-21.5,22.9-48,22.9s-48-10.3-48-22.9v-73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.7,295.1c0,55.1-35.3,71.5-69.2,68.6h-.3a29.31,29.31,0,0,1-26.4-29.2V295.2h95.9Z",
    fill: "#66b0f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "HEAD-2",
    "data-name": "HEAD",
    d: "M1868,276.3V280a14.77,14.77,0,0,1-14.8,14.8h-7.6l.1,1.7a42.68,42.68,0,0,1-42.7,42.7h-10.5a42.68,42.68,0,0,1-42.7-42.7l.1-1.7h-7.6a14.77,14.77,0,0,1-14.8-14.8v-3.7a14.77,14.77,0,0,1,14.8-14.8h9.7l1.1-18.1a26.25,26.25,0,0,1,1.2-8c28.6,7.1,62.1-11.3,71.1-16.8a26.42,26.42,0,0,1,17.1,24.7l1.1,18.1h9.7A14.9,14.9,0,0,1,1868,276.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "HAIR",
    d: "M1853.9,261.5h-10.4l-1.1-18.1a26.42,26.42,0,0,0-17.1-24.7c-9,5.4-42.5,23.8-71.1,16.8a26.25,26.25,0,0,0-1.2,8l-1.1,18.1h-6.5s-13.3-64.4-.2-76.2c9.7-8.7,98.5,10.3,108.3,23.8C1859,216.9,1853.9,261.5,1853.9,261.5Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FACE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1828.9,257.6a1.43,1.43,0,0,1-1-.4h0a28.26,28.26,0,0,0-17-5.4,1.5,1.5,0,0,1,0-3c11.5,0,18.6,5.8,18.9,6.1a1.55,1.55,0,0,1,.2,2.1A1.25,1.25,0,0,1,1828.9,257.6Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.9,288.6a.75.75,0,0,1-.5-.1,1.48,1.48,0,0,1-.9-1.9c2.8-7.4,2.1-16.7-1.8-24.9-2.3-5-5.6-8.6-8.5-9.6-6.4-2.2-15.4.9-15.5.9a1.49,1.49,0,1,1-1-2.8c.4-.1,10-3.4,17.4-.9,3.7,1.3,7.5,5.4,10.2,11.2,4.2,8.9,4.9,19.1,1.9,27.3A1.39,1.39,0,0,1,1790.9,288.6Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.6,304.5a1.54,1.54,0,0,1-1.4,1.6h-.1a1.52,1.52,0,0,1-1.5-1.4,13.56,13.56,0,0,0-.6-2.9,25.93,25.93,0,0,1-11.4,2.8c-6.3,0-10.1-2.6-10.3-2.8a1.51,1.51,0,1,1,1.7-2.5,16.27,16.27,0,0,0,8.6,2.3,22.87,22.87,0,0,0,10.1-2.5,9,9,0,0,0-1.2-1.6,1.45,1.45,0,0,1,.1-2.1,1.54,1.54,0,0,1,2.1.1C1806.9,295.8,1810.3,299.6,1810.6,304.5Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1815.69,
    cy: 270.93,
    rx: 2.5,
    ry: 5,
    transform: "translate(-13.34 113.48) rotate(-3.57)",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1774.89,
    cy: 270.93,
    rx: 2.3,
    ry: 4.6,
    transform: "translate(-13.42 110.94) rotate(-3.57)",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.2,281.1a1.54,1.54,0,0,1-1.5-1.5,7.92,7.92,0,0,0-7.9-7.9,1.5,1.5,0,0,1,0-3,10.93,10.93,0,0,1,10.9,10.9A1.47,1.47,0,0,1,1747.2,281.1Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.8,281.1a1.54,1.54,0,0,1-1.5-1.5,10.93,10.93,0,0,1,10.9-10.9,1.5,1.5,0,0,1,0,3,7.92,7.92,0,0,0-7.9,7.9A1.42,1.42,0,0,1,1847.8,281.1Z",
    fill: "#66b0f0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3658,2495,3229.7,1078.8a66.94,66.94,0,0,0-64.1-47.5H566.1a66.93,66.93,0,0,0-64.3,48.4L93.1,2495",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1278.2,
    y1: 552.7,
    x2: 2415.2,
    y2: 552.7,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PAPER",
    d: "M1672.8,767.9h268.6V998.6H1672.8Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BOY-2",
    "data-name": "BOY"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2677.2 1839.8 2552.3 1528.8 2753.4 1528.8 2677.2 1839.8",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2334.5,1113.7h0a154.78,154.78,0,0,1,136.8-82.4H2626l105.1,82.4Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2921,1477.8H2531.3L2678,1833.9c-10.2-16.6-71.3.7-136,40.4-63.9,39.2-107.1,86.4-98.3,103.6l-316.2-550.2c-82-138.8,18-314,179.2-314H3180l1.9,6C3238.9,1296.7,3106.9,1477.8,2921,1477.8Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3195.1,1215.8a270.43,270.43,0,0,1-20.8,93l-458-195h454.6l10.6,31C3188.9,1163.4,3193,1189.5,3195.1,1215.8Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2678.1,1833.9c10.2,16.6-34.4,61.9-99,101.6s-124.8,59.6-135,43,33.3-63.5,98-103.2S2667.8,1817.3,2678.1,1833.9Z",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534.6,1875.5l-284.4-502.8c-22.3-39.8,6.4-89,52.1-89h553.9c74.6,0,130.3-68.7,114.9-141.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440.8,1979.6c-10.2-16.6,33.9-69.4,101.3-108.7,75.7-44.1,124.7-57.2,139.3-33.8",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2683.6,
    y1: 1839.3,
    x2: 2497.8,
    y2: 1396.3,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2295.8,
    y1: 1110.4,
    x2: 2749.1,
    y2: 1110.4,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552.2,2001.4l-27-36.8L2488,1914a452.3,452.3,0,0,1,54-38.7c40.8-25,80.1-41.6,106.2-46.2l18.1,36.1,22.6,45C2672.9,1967.1,2552.2,2001.4,2552.2,2001.4Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2666.4,1865.2c-16.8,20.5-48.4,46.4-87.3,70.3a530.06,530.06,0,0,1-53.8,29.1l-37.2-50.6a452.3,452.3,0,0,1,54-38.7c40.8-25,80.1-41.6,106.2-46.2Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2812.5,2108.5l-274.4,197.1c-23.3,16.2-59.5,29.7-54.7-28.9,6.7-80.8,24.6-201,68.8-275.4h0c1.9-.5,120.7-34.8,136.7-91.2L2814,1999C2850,2027,2849.2,2081.6,2812.5,2108.5Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2539.5,2027.4c21.8,4.1,144.2-39.3,163.2-106.2",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510,2285.3s179.1-248.8,306.5-234.8C2955.2,2065.6,2396.6,2430.4,2510,2285.3Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2504.9,2319.2c-13.9.9-28.6-15.3-8.3-41.3,0,0,186.4-258,319.1-243.4,20.5,2.2,27.4,18.9,22.6,33.3",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "T-SHIRT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3196.1,1236.1c-63.4-15-221.2-54.5-401.2-96.1A281.19,281.19,0,0,1,2603,984.1L2439.1,629.5l99.2-157.2a177.94,177.94,0,0,1,139.6-82.7l97.6-6c98.4-6,177.4,55.4,207.4,149.3l198.5,580.8C3203.2,1168.1,3196.1,1236.1,3196.1,1236.1Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2525.4,649.4s52.2,82,171.1,100.1",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2595.8,500.2h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2595.8,500.2Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2844.9,671.1h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2844.9,671.1Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2923.8,741.1h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0C2926.1,758.4,2929.8,747.7,2923.8,741.1Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3075.1,1137.2h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11.1,11.1,0,0,0,3075.1,1137.2Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2990.4,947.9h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2990.4,947.9Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3025.5,811.7h0a11.11,11.11,0,0,0-8.2,16.5h0a11.05,11.05,0,0,0,19.5-.5h0A11,11,0,0,0,3025.5,811.7Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3089.4,1013.7h0a11.11,11.11,0,0,0-8.2,16.5h0a11.05,11.05,0,0,0,19.5-.5h0A11,11,0,0,0,3089.4,1013.7Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2824.4,795.8h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11.1,11.1,0,0,0,2824.4,795.8Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2769.3,909.1h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2769.3,909.1Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670.7,869.5h0a11.11,11.11,0,0,0-2.9-18.2h0a11.08,11.08,0,0,0-15.6,11.7h0A11.1,11.1,0,0,0,2670.7,869.5Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2758.2,1064.5h0a11.11,11.11,0,0,0-2.9-18.2h0a11.08,11.08,0,0,0-15.6,11.7h0A11,11,0,0,0,2758.2,1064.5Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2905.5,897.2h0a11.11,11.11,0,0,0-2.9-18.2h0a11.08,11.08,0,0,0-15.6,11.7h0A11.08,11.08,0,0,0,2905.5,897.2Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2955.8,1106.6h0a11.11,11.11,0,0,0-2.9-18.2h0a11.08,11.08,0,0,0-15.6,11.7h0A11,11,0,0,0,2955.8,1106.6Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2654.2,682.5h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2654.2,682.5Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2672.1,423.1h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2672.1,423.1Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2844.9,423.1h0a11.11,11.11,0,0,0-18.2,2.9h0a11.08,11.08,0,0,0,11.7,15.6h0A11,11,0,0,0,2844.9,423.1Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2845.2,535.1h0a11.09,11.09,0,0,0-3.9,18h0a11.1,11.1,0,0,0,18.8-5.2h0A11.1,11.1,0,0,0,2845.2,535.1Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747,471.3h0a11.11,11.11,0,0,0-5.7,17.5h0a11.09,11.09,0,0,0,19.2-3.3h0A11,11,0,0,0,2747,471.3Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2732.5,748.3h0a11.11,11.11,0,0,0-8.4,16.4h0a11.08,11.08,0,0,0,19.5-.2h0A11.09,11.09,0,0,0,2732.5,748.3Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2646.8,956.6h0a11.11,11.11,0,0,0-8.4,16.4h0a11.08,11.08,0,0,0,19.5-.2h0A11.09,11.09,0,0,0,2646.8,956.6Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2675.6,553.9h0a11.11,11.11,0,0,0-5.7,17.5h0a11.09,11.09,0,0,0,19.2-3.3h0A11.07,11.07,0,0,0,2675.6,553.9Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2758.4,609.9h0a11.11,11.11,0,0,0-5.7,17.5h0a11.09,11.09,0,0,0,19.2-3.3h0A11,11,0,0,0,2758.4,609.9Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2579.1,607.5h0a11,11,0,0,0-5.3-17.6h0a11,11,0,0,0-13.9,13.6h0A11.07,11.07,0,0,0,2579.1,607.5Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2958.2,607.8h0a11,11,0,0,0-5.3-17.6h0a11,11,0,0,0-13.9,13.6h0A11.06,11.06,0,0,0,2958.2,607.8Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2862,1013.2h0a11,11,0,0,0-5.3-17.6h0a11,11,0,0,0-13.9,13.6h0A11.13,11.13,0,0,0,2862,1013.2Z",
    fill: "#ffcf2d",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-3",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK-2",
    "data-name": "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2782.2,380.3l-6.7.3-97.6,6a176.75,176.75,0,0,0-70.3,19.3l-30-89.8,133.7-98Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2607.2,404.5h0a126,126,0,0,0,62.6-62.8l48.6-107.5-7.1-16.2-133.7,98Z",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-4",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2719.9,227.1a33.8,33.8,0,0,1-33.7,33.7h-29.4c-11.6,45.1-56.5,76-104.8,67.5l-22.1-3.9a45.63,45.63,0,0,1-37.3-51.2l25.9-129.7a44.91,44.91,0,0,1,59.5-35.1l42.9,17.2a57.49,57.49,0,0,1,38.8,54.3v12.5l26.5,1A33.72,33.72,0,0,1,2719.9,227.1Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670.1,233.6a23.26,23.26,0,0,1,23.3-23.3",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2532.9,170.8s21,0,36,20.1",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2541.94,
    cy: 207.33,
    rx: 10.7,
    ry: 5,
    transform: "matrix(0.18, -0.98, 0.98, 0.18, 1883.45, 2671.24)",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAIR-2",
    "data-name": "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2686.2,193.4a33.72,33.72,0,0,1,33.7,33.7v.5c15-23.1,51.8-81.9,51.8-101.8,0-26.7-33.3-53.4-67.8-41.2q3.45-2.55,7.2-5.4c13.3-10.4,20.3-18.2,21.4-23.8a6.53,6.53,0,0,0-.9-5.2c-4-5.7-8.4-8.2-13.1-7.4-6.9,1.1-14,9.6-21.1,25.2a190.3,190.3,0,0,0-7.1,18.4c-2.8-16.7-16.3-72-74.3-63.5-20,2.9-29.4,11.2-32,20.3-16.6-13-38.8-23.2-57.2-13.5-31.8,16.7-27.9,44.1-9.5,63.5-17.4-.3-29.6,4.8-29.6,19.5,0,13.5,13.9,20,33,22.6s43.6,1.2,64.8-1.2c15.1-1.7,28.7-3.8,37.4-5.3-5.8,11.9-8.1,22.1-7.6,30.7.9,17.8,13.8,28.3,32,32a80.88,80.88,0,0,0,12.4,1.5Zm32.9-146.6a3.08,3.08,0,0,1,1-.1c2.8,0,5.5,2,8.2,5.8a3,3,0,0,1,.3,2.1c-1.6,8.1-22.1,23.5-34,31.6C2699.3,72.4,2709.2,48.5,2719.1,46.8Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2606.4,76.4c-6.9,0-13.9-3.7-19-10.2-5.7-7.2-7.6-16.1-5.2-23.8a2,2,0,0,1,2.3-1.4,1.5,1.5,0,0,1,1.1.4c15.1,10.8,27.2,26.2,25.4,32.3a3.54,3.54,0,0,1-3.4,2.7Zm-21-30.2a22.91,22.91,0,0,0,5.1,17.5c4.5,5.7,10.7,9,16.7,8.6C2607.4,69.7,2600.7,57.8,2585.4,46.2Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "HANDS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2409,959.4H1769a20,20,0,0,1-16.9-30.7l85.2-133.8a60.2,60.2,0,0,1,50.8-27.9h433.2Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1902.2,767.1l51-84a16.79,16.79,0,0,1,14.3-8.1h0a16.76,16.76,0,0,1,14.3,25.5l-40.5,66.6Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2409,959.4H2265.1l-1-1c-35-36-49.9-90.6-30.2-143.2l20.5-48.2h66.9Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.4,869.6h-80.2a15.12,15.12,0,0,0-13.1,7.6l-8.5,14.8a15.05,15.05,0,0,0,13.1,22.5h64.5a32.25,32.25,0,0,0,27.5-15.4l6.9-11.3A12,12,0,0,0,1859.4,869.6Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.7,914.5h-80.2a15.12,15.12,0,0,0-13.1,7.6l-8.5,14.8a15.05,15.05,0,0,0,13.1,22.5h64.5A32.25,32.25,0,0,0,1842,944l6.9-11.3A12,12,0,0,0,1838.7,914.5Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.3,824.1h-80.2a15.12,15.12,0,0,0-13.1,7.6l-8.5,14.8a15.05,15.05,0,0,0,13.1,22.5h64.5a32.25,32.25,0,0,0,27.5-15.4l6.9-11.3A12,12,0,0,0,1882.3,824.1Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.4,869.6h-80.2a15.12,15.12,0,0,0-13.1,7.6l-8.5,14.8a15.05,15.05,0,0,0,13.1,22.5h64.5a32.25,32.25,0,0,0,27.5-15.4l6.9-11.3A12,12,0,0,0,1859.4,869.6Z",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.7,914.5h-80.2a15.12,15.12,0,0,0-13.1,7.6l-8.5,14.8a15.05,15.05,0,0,0,13.1,22.5h64.5A32.25,32.25,0,0,0,1842,944l6.9-11.3A12,12,0,0,0,1838.7,914.5Z",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.3,824.1h-80.2a15.12,15.12,0,0,0-13.1,7.6l-8.5,14.8a15.05,15.05,0,0,0,13.1,22.5h64.5a32.25,32.25,0,0,0,27.5-15.4l6.9-11.3A12,12,0,0,0,1882.3,824.1Z",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1998.4,891a99.4,99.4,0,0,1-65.5-24.6l-30.4-26.6h-28l-7.2,7.7c-12.9,13.8-28.8,21.7-47.7,21.7h-13.4a8.91,8.91,0,0,1-7.5-13.7l33.7-52.8h166.1V891Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1832.4,802.7l-33.7,52.8a8.91,8.91,0,0,0,7.5,13.7h13.4c18.9,0,34.8-7.8,47.7-21.7l7.2-7.7h28l30.4,26.6a99.72,99.72,0,0,0,65.5,24.6",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2673.6,772.4,2520.9,943a169.26,169.26,0,0,1-126.2,56.4h0c-95.2,0-161.1-95-127.7-184.2L2448.4,389l-61.3-34.3a29.92,29.92,0,0,1-11-28.7l10.4-70.1c3.2-15.6,19.1-27.8,34.6-31.4l71.8-16.2a8.8,8.8,0,0,1,10.7,9.9l-10.4,54.1c-4.1,26.4,13.7,49.2,40.1,53.7h0c21.6,3.7,36.8,25.4,34.8,47.2l-48.9,305C2519.1,678.4,2569.2,756.5,2673.6,772.4Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2556.5,
    y1: 445.7,
    x2: 2497.5,
    y2: 828.8,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2434.2,261l-.8,24.8c-.3,10.2,5.8,19.2,14.6,21.7l91.9,18.6",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2602.4,334.1l-73.5-9.8a45.63,45.63,0,0,1-37.3-51.2l9.5-54.3a7.14,7.14,0,0,0-8.7-8.2l-75,17.5",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2561.8,
    y1: 897,
    x2: 2760.6,
    y2: 675.8,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2450.5,
    y1: 389.1,
    x2: 2485.6,
    y2: 389.1,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2434.3,267.6v8c0,9.5,6.9,17.3,15.4,17.3h11c4.8,0,8.6-4.3,8.6-9.7l.7-52.2c.1-8.1-8.5-13.1-15.5-11.4",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470,267.6v8c0,9.5,6.9,17.3,15.4,17.3h7",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3134.1,
    y1: 1528.8,
    x2: 3250.2,
    y2: 2495,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2630.9,
    y1: 1528.8,
    x2: 2514.8,
    y2: 2495,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2554.6,
    y1: 2163.2,
    x2: 3210.3,
    y2: 2163.2,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2564,1531.8h631a15.19,15.19,0,0,0,15.2-15.2V1496a15.19,15.19,0,0,0-15.2-15.2H2564a15.19,15.19,0,0,0-15.2,15.2v20.6A15.19,15.19,0,0,0,2564,1531.8Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GIRL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PAPER-2",
    "data-name": "PAPER"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1514 800.6 1417.4 999.4 1125.5 999.4 1242.8 800.6 1514 800.6",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450,849.1s-12.7-21.7-43.2-16.1c-22.8,4.1-49.8,22.9-66.4,12.8s-31.3-22.7-52.8-16.7a130.78,130.78,0,0,0-37.4,17.5",
    fill: "none",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440,880.1s-12.7-21.7-43.2-16.1c-22.8,4.1-49.8,22.9-66.4,12.8s-31.3-22.7-52.8-16.7a130.78,130.78,0,0,0-37.4,17.5",
    fill: "none",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "GIRL-2",
    "data-name": "GIRL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS-2",
    "data-name": "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT-2",
    "data-name": "LEFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1623.8,1692.8c0,26.7-74.1,48.3-166.9,48.3s-164.7-21.6-164.7-48.3,71.9-48.3,164.7-48.3S1623.8,1666.2,1623.8,1692.8Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.1,1660.3v345l-10.5-49.8a116,116,0,0,0-160.8-81.8c-.5.2-1,.5-1.6.7L1369.7,1734l-21.4-78.1c29.3-7.1,67.2-11.4,108.6-11.4C1506.1,1644.5,1550.4,1650.6,1581.1,1660.3Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.1,1660.3v65c-30.7,9.7-75,15.8-124.2,15.8a520.35,520.35,0,0,1-87.2-7l-21.4-78.1c29.3-7.1,67.2-11.4,108.6-11.4C1506.1,1644.5,1550.4,1650.6,1581.1,1660.3Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573.7,1995.2c2.7.8,28.1,7.9,50.6,7.9,12.2,0,23.5-2.1,29.9-8.5,5.5-5.5,6.8-13.5,3.9-23.6-2.6-9-7.6-14.6-14.9-16.6-13.4-3.6-32,6.4-46.7,16.9,22.9-27.8,45.5-63.1,37.1-86.2a22,22,0,0,0-18.3-14.7c-7.1-.8-13.7,1.7-16.8,6.4-14.4,21.9-26.2,111.8-26.7,115.6Zm29-115.6c1.8-2.7,5.6-4.3,10-4.3a14.77,14.77,0,0,1,2.1.1,16.8,16.8,0,0,1,14.2,11.4c2.2,6.1,3,17.3-5.9,36.1-8.4,17.8-23.6,38.7-45.2,62.4C1581.1,1962.5,1591.3,1896.9,1602.7,1879.6Zm48,111.5c-6.6,6.6-21.6,8.6-43.5,5.8a239,239,0,0,1-27.9-5.4,232.37,232.37,0,0,1,21.6-17.1c17.8-12.3,32-17.6,41.1-15.1,5.5,1.5,9.2,5.8,11.4,13.1C1655.8,1980.8,1654.9,1986.9,1650.7,1991.1Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.7,1902.4l-23.1,25.9a90.64,90.64,0,0,0-10.6,106.2l101.7,174.4a110.91,110.91,0,0,0,95.8,55h42.1a47.88,47.88,0,0,0,46.9-57.8l-53-250.5a115.82,115.82,0,0,0-113.4-91.9h0A115.37,115.37,0,0,0,1370.7,1902.4Z",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.4,1977.8l131.3,254.4c6.2,11.5,13.9,18.9,22.7,23.6a48,48,0,0,1-26.8,8.2h-42.1a110.88,110.88,0,0,1-95.8-55L1337,2034.5a93.38,93.38,0,0,1-9.3-22.2c-14.4-53.5,46.5-95.5,92.2-64.1A113.52,113.52,0,0,1,1449.4,1977.8Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.7,1978.4H1328.5a43.26,43.26,0,0,1,2.1-5.4h115.2c1.2,1.6,2.4,3.2,3.6,4.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.5,2012.8H1327.9a4.33,4.33,0,0,0-.1-.5c-.4-1.6-.8-3.3-1.1-4.9h138.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1485.3 2047.3 1344.5 2047.3 1341.3 2041.8 1482.5 2041.8 1485.3 2047.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1503.1 2081.8 1364.6 2081.8 1361.4 2076.3 1500.3 2076.3 1503.1 2081.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1520.9 2116.2 1384.7 2116.2 1381.5 2110.8 1518.1 2110.8 1520.9 2116.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1538.7 2150.7 1404.8 2150.7 1401.6 2145.2 1535.8 2145.2 1538.7 2150.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1556.5 2185.2 1424.9 2185.2 1421.7 2179.7 1553.6 2179.7 1556.5 2185.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.2,2219.6H1445.8c-1.3-1.8-2.6-3.6-3.8-5.4h129.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.5,2254.1H1488.9a104,104,0,0,1-10.5-5.4h114.9A61.44,61.44,0,0,0,1600.5,2254.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT-2",
    "data-name": "RIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214.2,1685.7c-.9,26.4-75.8,47.8-168,47.8s-167.1-21.3-168-47.8V1477.8h336Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.9,1720.2l-.5,24.7-4.8,241.1v-7a112.11,112.11,0,0,0-112.1-112.1h-6.8a118.22,118.22,0,0,0-81.2,32.1l-14.7-99.4-9.1-61.5c24.6,4.1,53.1,6.4,83.4,6.4C1108.5,1744.4,1162.8,1734.6,1191.9,1720.2Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.9,1720.2l-.5,24.7c-37.2,26.4-152.1,58.9-219.5,54.6l-9.1-61.5a526.72,526.72,0,0,0,83.4,6.4C1108.5,1744.4,1162.8,1734.6,1191.9,1720.2Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.6,2267.2h18.6a88.43,88.43,0,0,0,88.4-88.4V1979a112.11,112.11,0,0,0-112.1-112.1h-6.8c-72,0-127.5,63.5-117.8,134.9l23.5,172.8A107.23,107.23,0,0,0,1079.6,2267.2Z",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.8,2243.1a88.23,88.23,0,0,1-60.6,24.1h-18.6a107.05,107.05,0,0,1-106.1-92.6L950,2001.8c-.4-3.3-.8-6.6-.9-9.8a80.08,80.08,0,0,1,158.2,0l30.9,210.9A69.71,69.71,0,0,0,1158.8,2243.1Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098,1965.3H958.3a49.26,49.26,0,0,1,3.4-5.4h133A48.6,48.6,0,0,1,1098,1965.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.4,1999.7H949.7c-.2-1.8-.4-3.6-.5-5.4h158.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1113.5 2034.2 954.4 2034.2 953.6 2028.8 1112.7 2028.8 1113.5 2034.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1118.5 2068.7 959.1 2068.7 958.3 2063.2 1117.7 2063.2 1118.5 2068.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1123.6 2103.1 963.8 2103.1 963 2097.7 1122.8 2097.7 1123.6 2103.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1128.6 2137.6 968.4 2137.6 967.7 2132.2 1127.8 2132.2 1128.6 2137.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1133.7 2172.1 973.1 2172.1 972.4 2166.6 1132.9 2166.6 1133.7 2172.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.8,2206.5H983q-1.35-2.7-2.4-5.4h157.3l.3,1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.7,2241H1009.4c-2-1.7-4-3.6-5.8-5.4h148.5A59.54,59.54,0,0,0,1156.7,2241Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CLOTHES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1286.9,605.1V773.5c-7.3-19.1-65.1-16.4-128.7,7.7-54.5,20.7-95.4,49.1-101.4,68.8V613a195.28,195.28,0,0,1,95.6-167.9C1227.6,458.2,1286.9,523.7,1286.9,605.1Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.4,452.7A195.09,195.09,0,0,0,968.6,613V808.5H683.9l39.3-169.2A215.54,215.54,0,0,1,860.1,485.2Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.2,1289.5V1682c0-26.7-78.5-48.3-171.3-48.3s-168,21.6-168,48.3V1493.9a16,16,0,0,0-16-16H762.5c-153.5,0-267-142.9-232.3-292.4L653.4,654.7A215.51,215.51,0,0,1,827.3,490.9l32.8-5.6A215.54,215.54,0,0,0,723.2,639.4L683.9,808.6H968.6V613a195.21,195.21,0,0,1,83.8-160.3h0l45-7.6a161.17,161.17,0,0,1,27.5-2.3h3.5c1.1,0,2.2.1,3.2.1h.6c.8,0,1.7.1,2.5.1h.4c.5,0,1,.1,1.4.1.9.1,1.7.1,2.6.2l3.1.3,2.9.3c.2,0,.4.1.7.1,1,.1,2.1.3,3.1.4h.2c1.1.2,2.2.3,3.3.5a195.28,195.28,0,0,0-95.6,167.9v480.5h375.4C1540.4,1093.5,1628.2,1181.2,1628.2,1289.5Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.9,448.3c-51.2,35.6-90.4,99.1-90.4,164.7V808.5H683.8l39.3-169.2c16.7-72.1,64.5-130.7,132.6-155.2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.9,1433.6a235.72,235.72,0,0,1,55.6-152.1",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873,1413.7a2.3,2.3,0,0,1-1.4-.4l-13.2-7.2a3,3,0,0,1,2.9-5.3l13.2,7.2a3,3,0,0,1,1.2,4.1A3.15,3.15,0,0,1,873,1413.7Zm13.2-3.4a2.88,2.88,0,0,1-2.6-1.6,3,3,0,0,1,1.2-4.1l13.2-7.2a3.07,3.07,0,0,1,4.1,1.2,3,3,0,0,1-1.2,4.1l-13.2,7.2A4.19,4.19,0,0,1,886.2,1410.3Zm-39.6-10.9a2.3,2.3,0,0,1-1.4-.4l-13.2-7.2a3,3,0,0,1,2.9-5.3l13.2,7.2a3,3,0,0,1,1.2,4.1A3.15,3.15,0,0,1,846.6,1399.4Zm65.9-3.5a2.88,2.88,0,0,1-2.6-1.6,3,3,0,0,1,1.2-4.1l13.2-7.2a54.69,54.69,0,0,0,6.5-4.1,3,3,0,1,1,3.6,4.8,67.57,67.57,0,0,1-7.2,4.6l-13.2,7.2A2.82,2.82,0,0,1,912.5,1395.9Zm-92-11.3a3.23,3.23,0,0,1-1.8-.6,61.37,61.37,0,0,1-11.4-10.8,3,3,0,1,1,4.6-3.8,55.66,55.66,0,0,0,10.3,9.7,3.14,3.14,0,0,1,.7,4.2A2.61,2.61,0,0,1,820.5,1384.6Zm122.9-10.5a2.81,2.81,0,0,1-1.9-.7,2.91,2.91,0,0,1-.4-4.2,55.66,55.66,0,0,0,7.5-12.1,3,3,0,0,1,5.5,2.5,60.64,60.64,0,0,1-8.3,13.3A3.13,3.13,0,0,1,943.4,1374.1Zm-141.7-12.4a3,3,0,0,1-2.7-1.7,65.61,65.61,0,0,1-4.8-15,3,3,0,1,1,5.9-1.1,57.43,57.43,0,0,0,4.3,13.5,3,3,0,0,1-1.5,4A2.66,2.66,0,0,1,801.7,1361.7Zm154.1-14.6h-.5a3,3,0,0,1-2.4-3.5,55.24,55.24,0,0,0,.9-9.9v-4.5a3,3,0,0,1,6,0v4.5a57.72,57.72,0,0,1-1,11A3.1,3.1,0,0,1,955.8,1347.1Zm-159.6-14.6a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3.08,3.08,0,0,1,796.2,1332.5Zm160.5-15.3a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3,3,0,0,1,956.7,1317.2Zm-160.5-14.7a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3.08,3.08,0,0,1,796.2,1302.5Zm160.5-15.3a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3,3,0,0,1,956.7,1287.2Zm-160.5-14.7a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3.08,3.08,0,0,1,796.2,1272.5Zm160.5-15.3a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3,3,0,0,1,956.7,1257.2Zm-160.5-14.7a3,3,0,0,1-3-3v-12.9h8.1a3,3,0,0,1,0,6h-2.1v6.9A3.08,3.08,0,0,1,796.2,1242.5Zm155.1-9.9h-15a3,3,0,1,1,0-6h15a3,3,0,0,1,0,6Zm-30,0h-15a3,3,0,1,1,0-6h15a3,3,0,0,1,0,6Zm-30,0h-15a3,3,0,1,1,0-6h15a3,3,0,0,1,0,6Zm-30,0h-15a3,3,0,1,1,0-6h15a3,3,0,0,1,0,6Zm-30,0h-15a3,3,0,0,1,0-6h15a3,3,0,0,1,0,6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590,1397.1a2.88,2.88,0,0,1-2.6-1.6,3,3,0,0,1,1.2-4.1l12.2-6.7c.3-.2.6-.3.9-.5a3,3,0,0,1,3,5.2,3.13,3.13,0,0,1-1,.5l-12.2,6.7A2.26,2.26,0,0,1,590,1397.1Zm25.3-16a2.84,2.84,0,0,1-2.2-1,3,3,0,0,1,.2-4.2,63.9,63.9,0,0,0,9.3-10.8,3,3,0,0,1,5,3.4,72.11,72.11,0,0,1-10.2,11.9A3.52,3.52,0,0,1,615.3,1381.1Zm16.7-24.6a4.25,4.25,0,0,1-1.1-.2,3,3,0,0,1-1.7-3.9,66.78,66.78,0,0,0,3.6-13.8,3,3,0,1,1,6,.8,66.59,66.59,0,0,1-3.9,15.2A3.25,3.25,0,0,1,632,1356.5Zm4.3-29.4a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3,3,0,0,1,636.3,1327.1Zm0-30a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3,3,0,0,1,636.3,1297.1Zm0-30a3,3,0,0,1-3-3v-15a3,3,0,0,1,6,0v15A3,3,0,0,1,636.3,1267.1Zm0-30a3,3,0,0,1-3-3v-1.5h-7.5a3,3,0,0,1,0-6h13.5v7.5A3,3,0,0,1,636.3,1237.1Zm-25.5-4.5h-15a3,3,0,0,1,0-6h15a3,3,0,0,1,3,3A3,3,0,0,1,610.8,1232.6Zm-30,0h-15a3,3,0,0,1,0-6h15a3,3,0,0,1,3,3A3,3,0,0,1,580.8,1232.6Zm-30,0h-15a3,3,0,0,1,0-6h15a3,3,0,0,1,3,3A3,3,0,0,1,550.8,1232.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND-2",
    "data-name": "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1286.9,773.5c7.3,19.1-38.9,53-102.4,77.1s-120.4,27.8-127.7,8.6,37.8-53.8,101.4-77.9S1279.6,754.3,1286.9,773.5Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.4,1393.9v10.6a44,44,0,0,0-10.3-1.2h-12.9a44.37,44.37,0,0,1-41.6-29.2l36.6-4.9A24.91,24.91,0,0,1,1322.4,1393.9Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.2,1447.4v81.4a34.4,34.4,0,0,1-34.4,34.4h-38.3a33.9,33.9,0,0,1-24.3-10.1,34.32,34.32,0,0,1-10.1-24.3H1274a14.77,14.77,0,0,0,14.8-14.8v-21.3a14.77,14.77,0,0,0-14.8-14.8H1146.7a90,90,0,0,1-90-90V850.1c6-19.7,46.9-48.2,101.4-68.8,37.2-14.1,72.5-20.9,96.8-20.3v598.2a44.21,44.21,0,0,0,44.2,44.2H1312A44,44,0,0,1,1356.2,1447.4Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.9,760.9v54.4c-18.1,12.2-42.6,24.7-70.5,35.2-63.6,24.1-120.4,27.8-127.7,8.6V850c6-19.7,46.9-48.2,101.4-68.8C1195.4,767.1,1230.6,760.3,1254.9,760.9Z",
    fill: "#73325a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-5",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK-3",
    "data-name": "NECK"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1088.6 355.8 1051 452.7 857.2 487.4 907.8 355.8 1088.6 355.8",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1088.6 355.8 1068.3 408.2 876.1 438.2 907.8 355.8 1088.6 355.8",
    fill: "#73325a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAIR-3",
    "data-name": "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1202.2,158.6c0,13.1-22.7,27.6-48.9,39.8-35.7,16.7-77.8,29.4-77.8,29.4l-28.4,53.5c38.6,20.5,53.7,57.3,59.7,83a137.78,137.78,0,0,1,3.8,28.1H838.4s-71.5-231.6,100.8-287C1044.6,71.5,1202.2,127.5,1202.2,158.6Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 70.7,
    r: 67.7,
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-6",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1106.7,364.3c-5.6-24.3-19.6-58.9-54.1-79.8h-8.9a29.8,29.8,0,0,1,0-59.6l37.7.8h1c.7-.2,1.4-.5,2.2-.7,10.2-2.2,42.5-10,69.3-23.4l3.1,18.5,10,59.3C1173.8,320.1,1145.9,357.6,1106.7,364.3Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.9,220c-32.8,13.3-75.6,5.6-75.6,5.6s40.3-8,72.5-24.1Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.9,260.4a20.57,20.57,0,0,0-20.6-20.6",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR-2",
    "data-name": "CHAIR"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1172.8,
    y1: 1528.8,
    x2: 1288.9,
    y2: 2495,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 669.5,
    y1: 1528.8,
    x2: 553.5,
    y2: 2495,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.3,
    y1: 2163.2,
    x2: 1249,
    y2: 2163.2,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.6,1528.8h705.1a15.19,15.19,0,0,0,15.2-15.2V1493a15.19,15.19,0,0,0-15.2-15.2H568.6a15.19,15.19,0,0,0-15.2,15.2v20.6A15.32,15.32,0,0,0,568.6,1528.8Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomtailored);
export default __webpack_public_path__ + "static/media/customtailored.8640d30a638e1a41e79d647fa5c0ec3c.svg";
export { ForwardRef as ReactComponent };